import { BuffetDataByType, Dishes } from './types';

export const BUFFET_TYPES = {
  HOT_SERVED: 0,
  TO_GO: 1,
};

export const LABEL_BY_BUFFET_TYPE = {
  [BUFFET_TYPES.HOT_SERVED]: 'Hot-Served Buffet',
  [BUFFET_TYPES.TO_GO]: 'To-Go Buffet',
};

export const KEY_BY_BUFFET_TYPE = {
  [BUFFET_TYPES.HOT_SERVED]: 'hot-served',
  [BUFFET_TYPES.TO_GO]: 'to-go',
};

export const LABEL_BY_KEY_BUFFET_TYPE = {
  [KEY_BY_BUFFET_TYPE[BUFFET_TYPES.HOT_SERVED]]: 'Hot-Served Buffet',
  [KEY_BY_BUFFET_TYPE[BUFFET_TYPES.TO_GO]]: 'To-Go Buffet',
};

export const BUFFET_STATIC_DATA: BuffetDataByType = {
  // TODO: update this image sources
  [BUFFET_TYPES.HOT_SERVED]: {
    images: [
      '/images/static/catering/product/hot-served/hotservedbuffet1.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet2.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet3.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet4.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet5.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet6.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet7.jpg',
      '/images/static/catering/product/hot-served/hotservedbuffet8.jpg',
    ],
    prologue:
      'Feed big groups without the fuss. Customisable 9-item menu with bold, balanced dishes — pick from flavour-packed mains, hearty carbs, and local-style desserts.',
    features: [
      'Includes 1 starter, 3 proteins, 1 carb, 2 veg, 1 dessert, 1 drink.',
    ],
    deliveryFee: {
      cbd: 80.0,
      nonCbd: 80.0,
      fixed: 80.0,
    },
    standardPricing: {
      minPax: 30,
      pricePerPax: 27,
    },
    bulkPricing: {
      minPax: 50,
      pricePerPax: 25,
    },
    dishes: {
      starters: {
        displayName: 'Starters',
        minSelection: 1,
        additionalPrice: 3,
        items: [
          { displayName: 'Low-Fat Caesar Salad' },
          { displayName: 'Chinese Tofu Salad' },
          { displayName: 'Low-Fat Mushroom Soup' },
          { displayName: 'Chinese Hot & Sour Soup' },
          { displayName: 'Chicken Sliders' },
          {
            displayName: 'Cheesy Beef Sliders',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Yummy Tandoori Chicken with Mint Chutney' },
          { displayName: 'Yummy Satay Chicken with Alfalfa' },
          { displayName: 'Yummy Basil Chicken on Bruchetta' },
          { displayName: 'Zesty Salmon with Alfalfa' },
        ],
      },
      proteins: {
        displayName: 'Proteins',
        minSelection: 3,
        additionalPrice: 3,
        items: [
          { displayName: 'Zesty Fish' },
          { displayName: 'Zesty Chicken' },
          { displayName: 'Yummy Chicken Bulgogi' },
          { displayName: 'Yummy Sambal Fish' },
          { displayName: 'Yummy Tandoori Chicken' },
          { displayName: 'Yummy Kungpao Chicken' },
          { displayName: 'Yummy Kopi Chicken' },
          { displayName: 'Yummy Chicken Panggang' },
          {
            displayName: 'Yummy Mongolian Beef',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Yummy Curry Chicken' },
          { displayName: 'Yummy Satay Chicken' },
          { displayName: 'Yummy Sesame Chicken' },
          {
            displayName: 'Black Peppery Beef',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Steamy Black Bean Chicken' },
        ],
      },
      carbs: {
        displayName: 'Carbs',
        minSelection: 1,
        additionalPrice: 2,
        items: [
          { displayName: 'Low-GI Red & Brown Rice' },
          { displayName: 'Short Grain Japanese Rice' },
          { displayName: 'Quinoa Lemak', specialAddonPrice: 2.5 },
          {
            displayName: 'Whole Wheat Sesame Garlic Penne',
            specialAddonPrice: 2.5,
          },
          {
            displayName: 'Bolognese Sauce Low GI Ban Mian',
            specialAddonPrice: 2.5,
          },
          { displayName: 'Low-GI Pineapple Rice' },
          {
            displayName: 'YB Brown Yam Rice',
            specialAddonPrice: 2.5,
          },
        ],
      },
      veggies: {
        displayName: 'Veggies',
        minSelection: 2,
        additionalPrice: 2.5,
        items: [
          { displayName: 'Chinese Cabbage' },
          { displayName: 'Sambal Long Beans' },
          { displayName: 'Stir-Fried Broccoli & Carrot Slices' },
          { displayName: 'Low-Fat Curry Mixed Veggies' },
          { displayName: 'Stir-fry Mixed Mushrooms' },
          { displayName: 'Stir-Fried Gai Lan' },
          { displayName: 'Garlic Eggplant' },
        ],
      },
      desserts: {
        displayName: 'Desserts',
        minSelection: 1,
        additionalPrice: 2,
        items: [
          { displayName: 'Red Bean Soup', isChilled: true },
          { displayName: 'Bo Bo Cha Cha', isChilled: true },
          { displayName: 'Cheng Tng', isChilled: true },
        ],
      },
      beverages: {
        displayName: 'Beverages',
        minSelection: 1,
        additionalPrice: 2,
        items: [
          {
            displayName: 'Home-Brewed Lemongrass Lime',
            isChilled: true,
          },
          { displayName: 'Home-Brewed Golden Pear', isChilled: true },
          {
            displayName: 'Home-Brewed Lemon Barley Drink',
            isChilled: true,
          },
          { displayName: 'Chrysanthemum Tea', isChilled: true },
        ],
      },
    },
  },
  [BUFFET_TYPES.TO_GO]: {
    images: [
      '/images/static/catering/product/to-go/to-go-buffet1.jpg',
      '/images/static/catering/product/to-go/to-go-buffet2.jpg',
      '/images/static/catering/product/to-go/to-go-buffet3.jpg',
      '/images/static/catering/product/to-go/to-go-buffet4.jpg',
      '/images/static/catering/product/to-go/to-go-buffet5.jpg',
    ],
    prologue:
      'For teams on the go or fuss-free events. 7 curated dishes featuring lean proteins, fragrant carbs, and old-school desserts, designed for convenience without compromising on taste.',
    features: [
      'Includes 1 starter, 2 proteins, 1 carb, 2 veg, 1 dessert.',
    ],
    deliveryFee: {
      cbd: 50.0,
      nonCbd: 40.0,
    },
    standardPricing: {
      minPax: 15,
      pricePerPax: 22,
    },
    bulkPricing: {
      minPax: 30,
      pricePerPax: 20,
    },
    dishes: {
      starters: {
        displayName: 'Starters',
        minSelection: 1,
        additionalPrice: 3,
        items: [
          { displayName: 'Low-Fat Caesar Salad' },
          { displayName: 'Chinese Tofu Salad' },
          { displayName: 'Low-Fat Mushroom Soup' },
          { displayName: 'Chinese Hot & Sour Soup' },
          { displayName: 'Chicken Sliders' },
          {
            displayName: 'Cheesy Beef Sliders',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Yummy Tandoori Chicken with Mint Chutney' },
          { displayName: 'Yummy Satay Chicken with Alfalfa' },
          { displayName: 'Yummy Basil Chicken on Bruchetta' },
          { displayName: 'Zesty Salmon with Alfalfa' },
        ],
      },
      proteins: {
        displayName: 'Proteins',
        minSelection: 2,
        additionalPrice: 3,
        items: [
          { displayName: 'Zesty Fish' },
          { displayName: 'Zesty Chicken' },
          { displayName: 'Yummy Chicken Bulgogi' },
          { displayName: 'Yummy Sambal Fish' },
          { displayName: 'Yummy Tandoori Chicken' },
          { displayName: 'Yummy Kungpao Chicken' },
          { displayName: 'Yummy Kopi Chicken' },
          { displayName: 'Yummy Chicken Panggang' },
          {
            displayName: 'Yummy Mongolian Beef',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Yummy Curry Chicken' },
          { displayName: 'Yummy Satay Chicken' },
          { displayName: 'Yummy Sesame Chicken' },
          {
            displayName: 'Black Peppery Beef',
            specialAddonPrice: 3.5,
          },
          { displayName: 'Steamy Black Bean Chicken' },
        ],
      },
      carbs: {
        displayName: 'Carbs',
        minSelection: 1,
        additionalPrice: 2,
        items: [
          { displayName: 'Low-GI Red & Brown Rice' },
          { displayName: 'Short Grain Japanese Rice' },
          { displayName: 'Quinoa Lemak', specialAddonPrice: 2.5 },
          {
            displayName: 'Whole Wheat Sesame Garlic Penne',
            specialAddonPrice: 2.5,
          },
          {
            displayName: 'Bolognese Sauce Low GI Ban Mian',
            specialAddonPrice: 2.5,
          },
          { displayName: 'Low-GI Pineapple Rice' },
          {
            displayName: 'YB Brown Yam Rice',
            specialAddonPrice: 2.5,
          },
        ],
      },
      veggies: {
        displayName: 'Veggies',
        minSelection: 2,
        additionalPrice: 2.5,
        items: [
          { displayName: 'Chinese Cabbage' },
          { displayName: 'Sambal Long Beans' },
          { displayName: 'Stir-Fried Broccoli & Carrot Slices' },
          { displayName: 'Low-Fat Curry Mixed Veggies' },
          { displayName: 'Stir-fry Mixed Mushrooms' },
          { displayName: 'Stir-Fried Gai Lan' },
          { displayName: 'Garlic Eggplant' },
        ],
      },
      desserts: {
        displayName: 'Desserts',
        minSelection: 1,
        additionalPrice: 2,
        items: [
          { displayName: 'Red Bean Soup', isChilled: true },
          { displayName: 'Bo Bo Cha Cha', isChilled: true },
          { displayName: 'Cheng Tng', isChilled: true },
        ],
      },
    },
  },
};

export const ADDON_TYPE: Record<keyof Dishes, string> = {
  starters: 'starter',
  proteins: 'protein',
  carbs: 'carb',
  veggies: 'veggies',
  desserts: 'dessert',
  beverages: 'beverage',
};
